import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品企画情報の取込要求を行う
 *
 * @export
 * @class RegistPlanGoodsInfoService
 * @extends {PlessJsonUploadServiceSub}
 */
@Injectable()
export class RegistPlanGoodsInfoService extends PlessJsonUploadServiceSub<any> {

  private nextFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistPlanGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistPlanGoodsInfoService
   */
  execute(file: File, nextFunc: Function): void {
    this.nextFunc = nextFunc;
    this.sendFile('registPlanGoodsInfo', this.getBody(), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistPlanGoodsInfoService
   */
  success(data: any) {
    this.nextFunc(data);
  }
}
